import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/es/integration/react';
import { ConnectedRouter } from 'react-router-redux';
import LanguageProvider from './containers/LanguageProvider';
import App from './containers/App';

const AppRoot = ({
  client,
  LDProvider,
  store,
  persistor,
  history,
  messages,
  onBeforeLift,
}) => {
  return (
    <ApolloProvider client={client}>
      <LDProvider>
        <Provider store={store}>
          <PersistGate
            loading={null}
            persistor={persistor}
            onBeforeLift={onBeforeLift}
          >
            <LanguageProvider messages={messages}>
              <ConnectedRouter history={history} store={store}>
                <App />
              </ConnectedRouter>
            </LanguageProvider>
          </PersistGate>
        </Provider>
      </LDProvider>
    </ApolloProvider>
  );
};

export default AppRoot;
